import footerController from './footer.controller.js';

function pageFooter() {
  return {
    template: require('./lloyds.pageFooter.html'),
    controller: footerController
  };
};
export default pageFooter;


// WEBPACK FOOTER //
// ./src/login/footer/lloyds.pageFooter.js